import { Start, Stop } from 'smg/buttons';
import * as countries from 'smg/countries';
import * as models from 'smg/customer-api/models';
import { PromotionalCode } from 'smg/customer-api/promos';
import { NewQuoteRequest } from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import { ShowError } from 'smg/errors';
import { BlockPastDates, ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import QueryString from 'smg/querystring';
import { Uploader } from 'smg/uploads';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

main();

function main() {
    const $form = document.querySelector('#trading-pin-quote-form') as HTMLFormElement;
    const $designFieldset = $form.querySelector('fieldset#design') as HTMLFieldSetElement;
    const $contactFieldset = $form.querySelector('fieldset#contact') as HTMLFieldSetElement;
    const $sportSelect = $designFieldset.querySelector('#sport-select') as HTMLElement;
    const $options = $designFieldset.querySelector('.form-design-section') as HTMLElement;

    $sportSelect.querySelectorAll<HTMLInputElement>('input[type="radio"]').forEach(radio =>
        radio.addEventListener('input', () => {
            if (radio.value === 'Baseball') {
                $form.querySelectorAll<HTMLElement>('.baseball-img').forEach(img => img.classList.remove('d-none'));
                $form.querySelectorAll<HTMLElement>('.softball-img').forEach(img => img.classList.add('d-none'));
            } else {
                $form.querySelectorAll<HTMLElement>('.softball-img').forEach(img => img.classList.remove('d-none'));
                $form.querySelectorAll<HTMLElement>('.baseball-img').forEach(img => img.classList.add('d-none'));
            }
            const $nextStep = $options.querySelector('.step.template') as HTMLElement;
            if ($nextStep) {
                $nextStep.classList.remove('d-none');
                $nextStep.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        }));

    const $templateStep = $options.querySelector('.step.template') as HTMLElement;
    const $sizeStep = $options.querySelector('.step.size') as HTMLElement;
    const $platingStep = $options.querySelector('.step.plating') as HTMLElement;
    const $upgradesStep = $options.querySelector('.step.upgrades') as HTMLElement;

    $templateStep.querySelectorAll<HTMLInputElement>('input[type="radio"]').forEach(radio => {
        radio.addEventListener('input', () => {
            $sizeStep.classList.remove('d-none');
            $sizeStep.scrollIntoView({
                behavior: 'smooth',
            });
        });
    });

    $sizeStep.querySelectorAll<HTMLInputElement>('input[type="radio"]').forEach(radio => {
        radio.addEventListener('input', () => {
            $platingStep.classList.remove('d-none');
            $platingStep.scrollIntoView({
                behavior: 'smooth',
            });
        });
    });

    $platingStep.querySelectorAll<HTMLInputElement>('input[type="radio"]').forEach(radio => {
        radio.addEventListener('input', () => {
            $upgradesStep.classList.remove('d-none');
            $contactFieldset.classList.remove('d-none');
            $upgradesStep.scrollIntoView({
                behavior: 'smooth',
            });
        });
    });

    const $upgradesNone = $upgradesStep.querySelector<HTMLInputElement>('.none-option');
    const $upgradesNoneInput = $upgradesNone?.querySelector<HTMLInputElement>('input[type="checkbox"]');

    $upgradesNone?.addEventListener('click', () => {
        $upgradesStep.querySelectorAll<HTMLInputElement>('input[name="upgrades"]').forEach($checkbox => {
            $checkbox.checked = false;
        });
    });

    $upgradesStep.querySelectorAll<HTMLInputElement>('input[name="upgrades"]').forEach($checkbox => {
        $checkbox.addEventListener('input', () => {
            if ($upgradesNoneInput && $upgradesStep.querySelector('input[name="upgrades"]:checked')) {
                $upgradesNoneInput.checked = false;
            }
        });
    });

    const $submit = $form.querySelector('[type="submit"]') as HTMLButtonElement;

    const $teamName = $form.querySelector('#team') as HTMLInputElement;
    const $teamColors = $form.querySelector('#colors') as HTMLInputElement;
    const $state = $form.querySelector('#state') as HTMLSelectElement;
    void countries.StateSelect(models.CountryID.COUNTRIES_UNITED_STATES, $state).catch(ShowError);
    const $ageLevel = $form.querySelector('#age-level') as HTMLInputElement;
    const $includeNumbers = $form.querySelector('#include-numbers') as HTMLInputElement;
    const $numbersWrapper = $form.querySelector('#numbers-wrapper') as HTMLElement;
    const $numbers = $form.querySelector('#numbers') as HTMLInputElement;
    const $quantity = $form.querySelector('#quantity') as HTMLInputElement;

    $includeNumbers.addEventListener('change', () => {
        if ($includeNumbers.checked) {
            $numbersWrapper.classList.remove('d-none');
            $numbers.required = true;
        } else {
            $numbersWrapper.classList.add('d-none');
            $numbers.required = false;
            $numbers.value = '';
        }
    });
    const $promo = $form.querySelector('#promo') as HTMLInputElement;
    const $date = $form.querySelector('#date') as HTMLInputElement;
    BlockPastDates($date, { earliest: 'tomorrow' });
    const $notes = $form.querySelector('#notes') as HTMLTextAreaElement;
    const $budget = $form.querySelector('#budget') as HTMLSelectElement;

    const $firstName = $form.querySelector('#first-name') as HTMLInputElement;
    const $lastName = $form.querySelector('#last-name') as HTMLInputElement;
    const $phone = $form.querySelector('#phone') as HTMLInputElement;
    const $email = $form.querySelector('#email') as HTMLInputElement;

    const u = new Uploader(document.querySelector('#trading-pin-uploads') as HTMLLabelElement, {
        confirmBtn: $submit || undefined,
    });

    const p = new Phone($phone);

    $promo.value = QueryString().get('promo') ?? '';

    // SKU of the product page the visitor came from (passed as ?sku= by the product-type
    // template), so the quote/order records the right NetworkSKUID for the reviews.io feed.
    const sku = QueryString().get('sku') || undefined;

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        const startLoading = () => {
            $contactFieldset.disabled = true;
            Start($submit);
        };
        const stopLoading = () => {
            $contactFieldset.disabled = false;
            Stop($submit);
        };

        startLoading();

        $promo.setCustomValidity('');
        if ($promo.value) {
            $promo.setCustomValidity('The promo code is not valid.');
            try {
                const promotionalCode = await PromotionalCode($promo.value);
                if (promotionalCode.promotionalCodeID) {
                    $promo.setCustomValidity('');
                }
            } catch (err) {
                console.error(err);
            }
        }

        stopLoading();
        if (!ReportValidity($form)) {
            return false;
        }
        startLoading();

        const $sportSelected = document.querySelector('[name="sport"]:checked') as HTMLInputElement;
        const $templateSelected = document.querySelector('[name="template"]:checked') as HTMLInputElement;
        const $sizeSelected = document.querySelector('[name="size"]:checked') as HTMLInputElement;
        const $platingSelected = document.querySelector('[name="plating"]:checked') as HTMLInputElement;
        const $upgradesSelected = document.querySelectorAll('[name="upgrades"]:checked');

        const extras: models.QuoteRequestCreateExtra[] = [];

        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Sport',
            value: $sportSelected.value,
        }));

        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Template',
            value: $templateSelected.value,
        }));

        if ($teamColors) {
            if ($teamColors.value) {
                extras.push(new models.QuoteRequestCreateExtra({
                    name: 'Colors',
                    value: $teamColors.value,
                }));
            }
        }

        if ($teamName?.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Team',
                value: $teamName.value,
            }));
        }

        if ($budget.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Budget',
                value: $budget.value,
            }));
        }

        if ($state.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'State',
                value: $state.options[$state.selectedIndex].text,
            }));
        }

        if ($ageLevel.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Age Level',
                value: $ageLevel.value,
            }));
        }

        if ($includeNumbers.checked && $numbers.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Numbers',
                value: $numbers.value,
            }));
        }

        const children: models.QuoteRequestCreateChild[] = [];

        children.push(new models.QuoteRequestCreateChild({
            child: 'Plating',
            option: $platingSelected.value,
        }));

        $upgradesSelected.forEach(upgrade => {
            const upgradeEl = upgrade as HTMLInputElement;
            children.push(new models.QuoteRequestCreateChild({
                child: upgradeEl.value,
            }));
        });

        // Awaited outside the chain — a PUT-failure throw would otherwise skip
        // the catch below and leave the form loading.
        let uploadIDs: number[];
        try {
            uploadIDs = await u.getUploadIDs();
        } catch (err) {
            stopLoading();
            ShowError(err, $form);
            return;
        }

        void NewQuoteRequest({
            form: 'trading pin design',
            company: $teamName?.value || '',
            email: $email?.value || '',
            name: new models.User({ firstName: $firstName?.value, lastName: $lastName?.value }).fullName(),
            phone: await p.format(),

            dateNeeded: $date.value || undefined,
            lineItem: 'Lapel Pins',
            type: 'Trading Pins',
            size: $sizeSelected.value,
            extras,
            children,

            uploadIDs,
            project: `${new Date().getFullYear()} ${$teamName ? $teamName.value : ''}`,
            notes: $notes?.value || '',
            promo: $promo.value,
            quantity: parseInt($quantity?.value, 10) || 0,
            sku,
        }).then(async resp => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'hugo-new-trading-pin-quote-request',
                'userData': {
                    'email': sess?.user.emailAddress.email || $email.value,
                    'phone': sess?.user.phoneNumber.phone || await p.format(),
                    'firstName': sess?.user.firstName || $firstName?.value,
                    'lastName': sess?.user.lastName || $lastName?.value,
                },
                'transactionId': resp.id,
                // 'products': gtmProducts,
                'total': resp.quotes?.[0].cachedTotal,
            });

            window.location.href = Relref('/thank-you');
        }).catch(err => {
            stopLoading();

            ShowError(err, $form);
        });
    });
}
